import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchProgressOverview } from '@blend-ed/blendx-platform/api';
import messages from './messages';
import { ProgressOverviewCard } from '@blend-ed/blendx-ui';


function ProgressOverviewComponent({ intl }) {
    const { data: progressOverview, isLoading } = useReactQuery({
        queryKey: ["progressOverview"],
        queryFn: fetchProgressOverview,
    });

    const data = useMemo(() => {
        if (isLoading) {
            return [
                { value: '-', label: intl.formatMessage(messages.ongoingCourses) },
                { value: '-', label: intl.formatMessage(messages.completedCourses) },
                { value: '-', label: intl.formatMessage(messages.completed) },
                { value: '-', label: intl.formatMessage(messages.bestStreak) },
            ];
        }

        return [
            { value: Math.round(progressOverview?.ongoing_courses), label: intl.formatMessage(messages.ongoingCourses) },
            { value: Math.round(progressOverview?.completed_courses), label: intl.formatMessage(messages.completedCourses) },
            { value: `${Math.round(progressOverview?.overall_block_completion)}%`, label: intl.formatMessage(messages.completed) },
            { value: Math.round(progressOverview?.best_streak), label: intl.formatMessage(messages.bestStreak) },
        ];
    }, [progressOverview, isLoading, intl]);

    return (
        <ProgressOverviewCard data={data} />
    );
}

ProgressOverviewComponent.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ProgressOverviewComponent);